import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { FaAdjustmentModels } from './FaAdjustmentModels';
import type { APIResponse } from '../../../Shared/shared';

export const addAdjustment = createAsyncThunk(
  'FaAdjustment/addAdjustment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/AddFaAdjustmentTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateAdjustment = createAsyncThunk(
  'FaAdjustment/updateAdjustment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/UpdateFaAdjustmentTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAdjustmentList = createAsyncThunk(
  'FaAdjustment/getAdjustmentList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<FaAdjustmentModels[]>>(
        'FATransaction/GetAdjustmentList'
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAdjustmentById = createAsyncThunk(
  'FaAdjustment/getAdjustmentById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<FaAdjustmentModels>>(
        `FATransaction/GetAdjustmentById?Id=${id}`
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getDepreciationByAssetId = createAsyncThunk(
//   'Depreciation/getDepreciationByAssetId',
//   async (AssetId: string, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.get<APIResponse<DepreciationModels>>(`FA/GetDepreciationByAssetId?AssetId=${AssetId}`);
//       if (data?.succeeded) {
//         return data?.data;
//       } else {
//         return rejectWithValue(data.message);
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState: {
  AdjustmentList: FaAdjustmentModels[];
  AdjustmentById: FaAdjustmentModels;
  // AdjustmentByAssetId: AdjustmentModels;
  loading: boolean;
  error: any | null;
} = {
  AdjustmentList: [],
  AdjustmentById: {} as FaAdjustmentModels,
  // AdjustmentByAssetId: {} as AdjustmentModels,
  loading: false,
  error: null
};

const FaAdjustment = createSlice({
  name: 'FaAdjustment',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getAdjustmentList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getAdjustmentList.fulfilled,
        (state, action: PayloadAction<FaAdjustmentModels[]>) => {
          state.loading = false;
          state.AdjustmentList = action.payload;
        }
      )
      .addCase(getAdjustmentList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      ////////////////////////////////////////////////////////////////
      .addCase(getAdjustmentById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAdjustmentById.fulfilled, (state, action: PayloadAction<FaAdjustmentModels>) => {
        state.loading = false;
        state.AdjustmentById = action.payload;
      })
      .addCase(getAdjustmentById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getDepreciationByAssetId.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getDepreciationByAssetId.fulfilled, (state, action: PayloadAction<DepreciationModels>) => {
    //   state.loading = false;
    //   state.DepreciationByAssetId = action.payload;
    // })
    // .addCase(getDepreciationByAssetId.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // })
  }
});

export default FaAdjustment.reducer;
